// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'

import PageView from 'syft-acp-core/components/PageView'
import { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'
import SalesForceView from 'syft-acp-core/entities2/EmployerSalesForceView'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

const EmployerSalesForceView = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <TrackingProvider
      value={{
        context: {
          employer_id: Number(params.id),
          salesforce_id: Number(params.salesforceID),
        },
      }}
    >
      <div className="page entity-list">
        <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
        <PageView
          title={[
            `Salesforce record ${params.salesforceID}`,
            recordLabel('Employer', params.id, employerName),
          ]}
          entityPage
        >
          <SalesForceView employerID={Number(params.id)} salesforceID={Number(params.salesforceID)} />
        </PageView>
      </div>
    </TrackingProvider>
  )
}

EmployerSalesForceView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      salesforceID: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerSalesForceView
